import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Event from '../../models/Event'
import Address from '../../models/Address'
import {
  Button,
  Confirm,
  Container,
  Header,
  List,
  ModalDimmer,
  Segment
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import moment from 'moment'

class CalendarEvent extends Component {
  static propTypes = {
    event: PropTypes.instanceOf(Event).isRequired,
    address: PropTypes.instanceOf(Address).isRequired,
    eventConfirmFunc: PropTypes.func.isRequired,
    eventDeleteFunc: PropTypes.func.isRequired,
    userRoleCalendar: PropTypes.string.isRequired,
    userRoleEvents: PropTypes.array.isRequired
  }

  state = { open: false }

  open = () => this.setState({ open: true })
  handleClose = () => this.setState({ open: false })

  handleConfirmDelete = () => {
    this.setState({ open: true })
  }

  render () {
    const {
      /** @var {Event} */
      event,
      /** @var {Address} */
      address,
      /** @var {string} */
      userRoleCalendar,
      /** @var {array} */
      userRoleEvents,
      /** @var {function} */
      eventConfirmFunc,
      /** @var {function} */
      eventDeleteFunc
    } = this.props
    const btnEditEvent = event.status !== Event.STATUS.COMPLETED && ['read_limited', 'read_all'].includes(userRoleCalendar)
    const btnConfirmEvent = event.status === Event.STATUS.SCHEDULED && ['read_limited', 'read_all'].includes(userRoleCalendar)
    const btnCanDelete = [Event.STATUS.CREATED, Event.STATUS.STARTED, Event.STATUS.EXPIRED, Event.STATUS.SCHEDULED].includes(event.status) && userRoleEvents.includes('delete')
    const btnEditReport = [Event.STATUS.CREATED, Event.STATUS.STARTED, Event.STATUS.EXPIRED].includes(event.status)
    const btnReviewEvent = event.status === Event.STATUS.WAITING_EVALUATION && ['read_limited', 'read_all'].includes(userRoleCalendar)
    const btnCompleted = event.status === Event.STATUS.COMPLETED
    return (
      <>
        <Confirm
          open={this.state.open}
          dimmer={<ModalDimmer blurring inverted={false} />}
          header='Confirmation de suppression'
          content="Êtes-vous sûr de vouloir effacer l'inspection planifiée?"
          cancelButton='Annuler'
          confirmButton='Confirmer'
          onCancel={this.handleClose}
          onConfirm={() => {
            eventDeleteFunc(event.id)
          }}
        />
        <div>
          {btnEditEvent &&
            <Button primary as={Link} to={`/events/edit/${event.id}`}>Modifier rendez-vous</Button>}
          {btnConfirmEvent &&
            <Button primary onClick={() => eventConfirmFunc(event.id)}>Confirmer rendez-vous</Button>}
          {btnEditReport &&
            <Button primary as={Link} to={`/events/event/${event.id}`}>Continuer le rapport</Button>}
          {btnReviewEvent &&
            <Button primary as={Link} to={`/events/review/${event.id}`}>Évaluer le rapport</Button>}
          {btnCompleted &&
            <Button primary as={Link} to={`/archives/event/${event.id}`}>Afficher le rapport</Button>}
          {btnCanDelete && <Button negative icon='trash' onClick={this.handleConfirmDelete} />}
          <Segment basic>
            <Container fluid>
              <Header as='h2'>Adresse</Header>
              <p>{address.fullAddress}</p>
            </Container>
          </Segment>
          <Segment basic>
            <Container fluid>
              <Header as='h2'>Heure de l'inspection</Header>
              <p>{moment(event.date_start).format('HH:mm')}<br />{moment(event.date_start).format('DD-MM-YYYY')}</p>
            </Container>
          </Segment>
          <Segment basic>
            <Container fluid>
              <Header as='h2'>Équipement</Header>
              <p>{event.clients_addresses_equipment.equipment.name}</p>
            </Container>
          </Segment>
          <Segment basic>
            <Container fluid>
              <Header as='h2'>Formulaires</Header>
              <List>
                {event.clients_addresses_equipment.forms.map(form => <List.Item key={form}>{form}</List.Item>)}
              </List>
            </Container>
          </Segment>
          <Segment basic>
            <Container fluid>
              <Header as='h2'>Statut inspection</Header>
              <p>{event.statusName}</p>
            </Container>
          </Segment>
          {event.status === Event.STATUS.STARTED &&
            <Segment basic>
              <Container fluid>
                <Header as='h2'>Temps restant</Header>
                <p>{event.remainingTime}</p>
              </Container>
            </Segment>}
        </div>
      </>
    )
  }
}

export default CalendarEvent
